import MojitoPresentation from 'mojito/presentation';

const { FlexPane, Text, Image } = MojitoPresentation.Components;

const EventCardBadge = props => {
    const { mojitoTools } = props;
    const { config, stringResolver } = mojitoTools;
    const { showIcon, showDot, l10nLabelKey } = config;
    const label = l10nLabelKey ? stringResolver.resolveString(l10nLabelKey) : '';

    if (!label && !showIcon && !showDot) {
        return null;
    }

    return (
        <FlexPane class="ta-EventCardBadge" config={config.container}>
            {showDot && <FlexPane class="ta-badgeDot" config={config.dot} />}
            {showIcon && <Image class="ta-badgeIcon" config={config.icon} />}
            {label && (
                <Text class="ta-badgeLabel" config={config.label}>
                    {label}
                </Text>
            )}
        </FlexPane>
    );
};

export default EventCardBadge;
